var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_1019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.599 7.79999C13.199 7.99999 12.999 8.39999 13.099 8.79999C13.699 10.5 12.899 12.3 11.199 13C9.49901 13.6 7.69901 12.8 6.99901 11.1C6.29901 9.39999 7.19901 7.69999 8.89901 6.99999C9.59901 6.69999 10.499 6.69999 11.199 6.99999C11.599 7.19999 12.099 6.89999 12.199 6.49999C12.399 6.09999 12.099 5.59999 11.699 5.49999C9.19901 4.49999 6.39901 5.79999 5.39901 8.29999C4.69901 10.1 5.19901 12.1 6.49901 13.5C8.39901 15.4 11.499 15.4 13.399 13.5C14.799 12.1 15.199 10.1 14.499 8.29999C14.499 7.89999 13.999 7.7 13.599 7.79999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6008 5.1C16.0426 5.1 16.4008 4.74183 16.4008 4.3C16.4008 3.85817 16.0426 3.5 15.6008 3.5C15.159 3.5 14.8008 3.85817 14.8008 4.3C14.8008 4.74183 15.159 5.1 15.6008 5.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6996 4.3001C19.6996 2.1001 17.8996 0.300098 15.6996 0.200098C11.8996 -0.0999023 8.09961 -0.0999023 4.29961 0.200098C2.09961 0.200098 0.299609 2.0001 0.199609 4.2001C-0.100391 8.0001 -0.100391 11.8001 0.199609 15.6001C0.199609 17.8001 1.99961 19.6001 4.19961 19.7001C6.09961 19.9001 7.99961 20.0001 9.99961 20.0001C11.9996 20.0001 13.7996 19.9001 15.6996 19.7001C17.8996 19.7001 19.6996 17.9001 19.6996 15.7001C19.9996 11.9001 19.9996 8.1001 19.6996 4.3001ZM18.0996 15.7001C18.0996 17.0001 16.9996 18.1001 15.6996 18.1001H15.5996C11.8996 18.5001 8.09961 18.5001 4.29961 18.1001C2.99961 18.1001 1.89961 17.0001 1.89961 15.7001C1.89961 15.7001 1.89961 15.7001 1.89961 15.6001C1.59961 11.8001 1.59961 8.1001 1.89961 4.3001C1.89961 3.0001 2.99961 1.9001 4.29961 1.9001C4.29961 1.9001 4.29961 1.9001 4.39961 1.9001C6.29961 1.7001 8.09961 1.6001 9.99961 1.6001C11.8996 1.6001 13.7996 1.7001 15.6996 1.9001C16.9996 1.9001 18.0996 3.0001 18.0996 4.3001C18.0996 4.3001 18.0996 4.3001 18.0996 4.4001C18.3996 8.1001 18.3996 11.9001 18.0996 15.7001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_1019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.6751fad60ef3c360896f600f40b78299.svg";
export { ForwardRef as ReactComponent };